module.exports = "/_next/static/images/safari-pinned-tab-590d1de49dee1ad577a6196505273cf4.svg";